define('Components/TitleWidget/js/TitleWidget',['hooks','Components/TitleWidget/js/views/TitleWidgetInstanceView'],
    function(hooks,TitleWidgetInstanceView){

    return function() {
        hooks.registerWidgetInstance('TitleWidget', TitleWidgetInstanceView);
    }
});
